import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';

const features = [
  'Get Started in 5 Min',
  'Online Support',
  'Free Start-Up Plan',
];

export const CTASection = () => {
  return (
    <section className="py-24 px-4">
      <div className="container mx-auto max-w-4xl">
        <div 
          className="rounded-3xl p-8 md:p-12 text-center"
          style={{
            background: 'linear-gradient(135deg, hsl(262, 83%, 53%, 0.2) 0%, hsl(262, 83%, 53%, 0.3) 100%)',
            backdropFilter: 'blur(20px)',
            border: '1px solid hsl(262, 83%, 53%, 0.3)',
          }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
            Ready to Scale Your Sales?
          </h2>
          <p className="landing-text-muted mb-8 text-lg">
            Start your free trial today and see the difference
          </p>

          {/* Feature chips */}
          <div className="flex flex-wrap items-center justify-center gap-4 mb-8">
            {features.map((feature) => (
              <div
                key={feature}
                className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10"
              >
                <CheckCircle className="w-4 h-4 text-cyan-400" />
                <span className="text-sm text-white">{feature}</span>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <Link to="/auth" className="landing-btn-primary inline-flex items-center gap-2">
            Join Beta
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
